import { render, staticRenderFns } from "./Artist-detail.vue?vue&type=template&id=0455f23b&"
import script from "./Artist-detail.vue?vue&type=script&lang=js&"
export * from "./Artist-detail.vue?vue&type=script&lang=js&"
import style0 from "./Artist-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports